import React from 'react';
import PropTypes from 'prop-types';
import Bar from './Bar';
import { UNLIMITED} from '../../dashboard/widgets/licensing/licensing-constants';
import './progress-bar.scss';


const ProgressBar = ({
    title,
    progressColor,
    progressPercent,
    textLeft,
    textRight,
    customClassName
}) => {
    const isUnlimited = textRight === UNLIMITED;

    return (
        <div className={customClassName}>
            <div>
                <p className="glu-progress-bar-title">{title}</p>
            </div>
            <div className="glu-bar-and-label">
                <Bar
                    progressColor={progressColor}
                    progressPercent={progressPercent}
                    textLeft={textLeft}
                />
                <div className="glu-progress-bar__label">
                    {!isUnlimited ? (
                        <p className="glu-progress-bar__label-text">{textRight}</p>
                    ) : (
                        <p className="glu-progress-bar__label-infinity">∞</p>
                    )}
                </div>
            </div>
        </div>
    );
};

ProgressBar.propTypes = {
    title: PropTypes.string.isRequired,
    progressColor: PropTypes.string.isRequired,
    progressPercent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    textLeft: PropTypes.string.isRequired,
    textRight: PropTypes.string.isRequired,
    customClassName: PropTypes.string
};

ProgressBar.defaultProps = {
    customClassName: ''
};

export default ProgressBar;
